import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import { initSessionTimeout, stopSessionTimeout } from '@/helpers/sessionTimeout'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseURL: process.env.VUE_APP_BASE_URL,
        access_token: localStorage.getItem('access_token') || '',
        logInUser: localStorage.getItem('logInUser') || {},
    },

    mutations: {
        clearUserData(state) {
            state.access_token = "";
            state.logInUser = {}
            localStorage.removeItem('access_token')
            localStorage.removeItem('logInUser')
            stopSessionTimeout();
        },
        addUserData: (state, data) => {
            state.logInUser = data
        },
    },

    actions: {
        registerUser({state, commit}, data) {
            return axios.post(`${state.baseURL}register`, {
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                password: data.password
            })
                .then((response) => {
                    if (response) {
                        // let access_token = response.data.token
                        // localStorage.setItem('access_token', access_token)
                        // state.access_token = access_token
                        // let userData = response.data.user
                        // localStorage.setItem('logInUser', JSON.stringify(userData))
                        // commit('addUserData', userData)
                        return response
                    }
                })
                .catch((error) => {
                    return error
                })
        },
        login({state, commit}, data) {
            return axios.post(`${state.baseURL}admin/login`, {
                email: data.email,
                password: data.password,
            },
                {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                })
                .then((response) => {
                    if (response) {
                        let access_token = response.data.token
                        localStorage.setItem('access_token', access_token)
                        state.access_token = access_token
                        let userData = response.data.user
                        localStorage.setItem('logInUser', JSON.stringify(userData))
                        commit('addUserData', userData)
                        initSessionTimeout(15);

                        return response
                    }
                })
                .catch((error) => {
                    return error
                })
        },
        forgotPassword({state}, data) {
            return axios.post(`${state.baseURL}forgot-password`, {
                email: data.email
            })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        resetPassword({state}, data) {
            return axios.post(`${state.baseURL}reset-password`, {
                email: data.email,
                token: data.token,
                password: data.password,
                password_confirmation: data.password_confirmation
            })
                .then(response => {
                    return response
                })
                .catch(error => {
                    return error
                })
        },
        sendContacts({state}, data) {
            return axios.post(`${state.baseURL}contact-us`, {
                email: data.email,
                phone: data.phone,
                message: data.message,
            })
                .then(response => {
                    return response
                })
                .catch(error => {
                    return error
                })
        },


        getListingSettings({state}) {
            return axios.get(`${state.baseURL}list/all`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getCountries({state}) {
            return axios.get(`${state.baseURL}admin/list/countries`)
                .then((response) => {
                    console.log(response, 'state')
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBedTypes({state}) {
            return axios.get(`${state.baseURL}admin/list/bed-types`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getPersonCapacities({state}) {
            return axios.get(`${state.baseURL}admin/list/person-capacities`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getTags({state}) {
            return axios.get(`${state.baseURL}admin/list/tags`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getPropertyTypes({state}) {
            return axios.get(`${state.baseURL}admin/list/property-types`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getRoomTypes({state}) {
            return axios.get(`${state.baseURL}admin/list/room-types`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBedroomsNumber({state}) {
            return axios.get(`${state.baseURL}admin/list/number-of-bedrooms`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBedNumbers({state}) {
            return axios.get(`${state.baseURL}admin/list/number-of-beds`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBathroomNumbers({state}) {
            return axios.get(`${state.baseURL}admin/list/number-of-bathrooms`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBathroomTypes({state}) {
            return axios.get(`${state.baseURL}admin/list/bathroom-types`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getGuestBathroomNumber({state}) {
            return axios.get(`${state.baseURL}admin/list/number-of-guest-bathrooms`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        ////
        getAllListings({state}) {
            return axios.get(`${state.baseURL}admin/listings`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getAllDrafts({state}) {
            return axios.get(`${state.baseURL}admin/listings/data/unpublic`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getTimes({state}) {
          return axios.get(`${state.baseURL}admin/list/times`)
              .then((response) => {
                  return response
              })
              .catch((error) => {
                  console.log(error)
              })
        },
        deleteListing({state}, data) {
            return axios.delete(`${state.baseURL}admin/listings/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        doSearch({state}, data) {
            const params = new URLSearchParams();
            for (const key in data) {
                if (Array.isArray(data[key])) {
                    data[key].forEach(val => params.append(key, val));
                } else if (!params.has(key) && data[key] !== '') {
                    params.set(key, data[key]);
                }
            }
            return axios.get(`${state.baseURL}search?${params.toString()}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        createListing({state}, data) {
            let formData = new FormData();
            formData.append('draft', data.draft);
            for (const [key, value] of Object.entries(data.basic_info)) {
                if (Array.isArray(value)) {
                    if (key === 'tags_ids') {
                        value.forEach(tagId => {
                            formData.append(`${key}[]`, tagId);
                        });
                    } else {
                        formData.append(key, JSON.stringify(value));
                    }
                } else if (value !== '') {
                    formData.append(key, value);
                }
            }

            for (const [key, value] of Object.entries(data.address)) {
                if (value !== '') {
                    formData.append(key, value);
                }
            }
            for (const [key, value] of Object.entries(data.price_and_fees)) {
                if (value !== '') {
                    formData.append(key, value);
                }
            }
            for (const [key, value] of Object.entries(data.additional_info)) {
                if (value !== '') {
                    formData.append(key, value);
                }
            }
            for (const [key, value] of Object.entries(data.contact_invoicing)) {
                if (value !== '') {
                    formData.append(key, value);
                }
            }
            for (const [key, value] of Object.entries(data.booking_settings)) {
                formData.append(key, value);
            }
            // console.log(data.selected_amenities, 'selected_amenities')
            // for (const [key, value] of Object.entries(data.selected_amenities)) {
            //     formData.append(key, value);
            // }
            // if (data.selected_amenities) {
            //     Object.entries(data.selected_amenities).forEach(([key, value]) => {
            //         formData.append(key, value);
            //     });
            // }
            if (data.selected_amenities && Array.isArray(data.selected_amenities)) {
                for (const amenity of data.selected_amenities) {
                    if (amenity && amenity.id) {
                        formData.append('amenities_ids[]', amenity.id);
                    }
                }
            }

            // for (const [key, value] of Object.entries(data.additional_info_checked)) {
            //     formData.append(key, value);
            // }
            Object.values(data.additional_info_checked).forEach(item => {
                const [key, value] = Object.entries(item)[0];
                formData.append(key, value);
            });
            console.log(data.images, 'aaaaaaaaaa')

            for (let image of data.images) {
                formData.append('images[]', image);
            }
            for (let i of data.image_sequences) {
                formData.append('image_sequences[]', i);
            }
            if(data.attachments.length) {
                for (let attachment of data.attachments) {
                    formData.append('attachments[]', attachment);
                }
                for (let name of data.attachments_file_name) {
                    formData.append('attachments_file_name[]', name);
                }
                for (let publicAttachment of data.attachments_is_public) {
                    formData.append('attachments_is_public[]', publicAttachment);
                }
            }
            data.rooms.forEach((room, index) => {
                formData.append(`rooms[${index}][bed_type_id]`, room.bed_type_id);
                formData.append(`rooms[${index}][quantity]`, room.quantity);
                formData.append(`rooms[${index}][room_number]`, room.room_number);
            });
            let url = ''
            if(data.id) {
                formData.append('listing_id', data.id);
                url = `${state.baseURL}admin/listings/${data.id}`
            } else {
                url = `${state.baseURL}admin/listings`
            }
            return axios.post(url, formData)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getMediaData({state}, data) {
            return axios.get(`${state.baseURL}admin/listing-media/${data}/media/`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        addMediaImage({state}, data) {
            let formData = new FormData();
            formData.append('type', data.type);
            formData.append('file', data.file);
            formData.append('sequence', data.sequence);
            formData.append('is_public', data.is_public);
          return axios.post(`${state.baseURL}admin/listing-media/${data.listing_id}/media`, formData)
              .then((response) => {
                  return response
              })
              .catch((error) => {
                  return error
              })
        },
        removeMedia({state}, data) {
          return axios.delete(`${state.baseURL}admin/listing-media/${data.listing_id}/media/${data.id}`)
              .then((response) => {
                  return response
              })
              .catch((error) => {
                  return error
              })
        },

        getStripeStatus({state}) {
            return axios.get(`${state.baseURL}stripe/status`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getStripeConnection({state}) {
            return axios.get(`${state.baseURL}stripe/connect`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        //
        getListingById({state}, data) {
            return axios.get(`${state.baseURL}admin/listings/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        sendInquiryPost({state}, data) {
            return axios.post(`${state.baseURL}bookings/inquiry`, {
                listing_id: data.listing_id,
                start_date: data.start_date,
                end_date: data.end_date,
                guests: data.guests,
                first_name: data.first_name,
                last_name: data.last_name,
                email_address: data.email_address,
                phone_number: data.phone_number,
                promotional_emails: data.promotional_emails,
            })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getReservedDates({state}, data) {
            return axios.get(`${state.baseURL}bookings/unavailable-dates?listing_id=${data.listing_id}&guests=${data.guests}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getReservationsAll({state}) {
            return axios.get(`${state.baseURL}admin/reservations`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getSelectList({state}) {
            return axios.get(`${state.baseURL}admin/reservations/select/list`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getReservationDetails({state}, data) {
            return axios.get(`${state.baseURL}bookings/reservation/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        changeResStatus({state}, data) {
           return axios.post(`${state.baseURL}admin/reservations/change/status`, {
                reservation_id: data.reservation_id,
                status_id: data.status_id
            })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        calculatePrice({state}, data) {
            return axios.get(`${state.baseURL}bookings/calculation?listing_id=${data.listing_id}&start_date=${data.start_date}&end_date=${data.end_date}&guests=${data.guests}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeReservation({state}, data) {
            return axios.delete(`${state.baseURL}admin/reservations/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getCategoryListings({state}, data) {
            return axios.get(`${state.baseURL}search/category/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        emailSubscribe({state}, data) {
          return axios.post(`${state.baseURL}subscribe`, {
              email: data.subscribe_email
          })
              .then((response) => {
                  return response
              })
              .catch((error) => {
                  return error
              })
        },
    //    admin
        createEditBlog({state}, data) {
            let formData = new FormData();

            // Common fields
            formData.append('title', data.title);
            formData.append('short_description', data.short_description);
            formData.append('long_description', data.long_description);

            // Image field (only append a real File/Blob)
            if (data.mode === 'new') {
                if (data.image instanceof File || data.image instanceof Blob) {
                    formData.append('image', data.image);
                }
            } else {
                if (data.image && typeof data.image !== 'string') {
                    formData.append('image', data.image);
                }
            }

            const url = data.mode === 'new'
                ? `${state.baseURL}admin/blogs`
                : `${state.baseURL}admin/blogs/${data.id}`;

            // Let axios handle success/error via promise; ensure multipart headers
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        getAdminBlogs({state}) {
            return axios.get(`${state.baseURL}admin/blogs`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeAdminBlog({state}, data) {
            return axios.delete(`${state.baseURL}admin/blogs/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getAllBlogs({state}) {
            return axios.get(`${state.baseURL}blogs`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        showBlog({state}, data) {
            return axios.get(`${state.baseURL}blogs/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getAdminData({state}) {
          return axios.get(`${state.baseURL}admin/data-count`)
              .then((response) => {
                  return response
              })
              .catch((error) => {
                  return error
              })
        },
        createEditTag({state}, data) {
            if(data.mode == 'new') {
                return axios.post(`${state.baseURL}admin/tags`, {
                    name: data.name
                })
                    .then((response) => {
                        return response
                    })
                    .catch((error) => {
                        return error
                    })
            } else {
                return axios.post(`${state.baseURL}admin/tags/update`, {
                    name: data.name,
                    tag_id: data.id
                })
                    .then((response) => {
                        return response
                    })
                    .catch((error) => {
                        return error
                    })
            }
        },
        getAdminTags({state}) {
            return axios.get(`${state.baseURL}admin/tags`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        deleteAdminTag({state}, data) {
            return axios.delete(`${state.baseURL}admin/tags/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        createBlockContact({state}, data) {
            return axios.post(`${state.baseURL}admin/blocked-mails`, {
                email: data
            })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getBlockedContacts({state}) {
            return axios.get(`${state.baseURL}admin/blocked-mails`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeBlockedContact({state}, data) {
            return axios.delete(`${state.baseURL}admin/blocked-mails/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getContacts({state}) {
            return axios.get(`${state.baseURL}admin/contacts`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeContact({state}, data) {
            return axios.delete(`${state.baseURL}admin/contacts/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        checkBlockEmail({state}, data) {
            return axios.get(`${state.baseURL}check-email-blocked/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getAdminReviews({state}) {
            return axios.get(`${state.baseURL}admin/reviews`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        createEditReview({state}, data) {
            let formData = new FormData();
            formData.append('first_name', data.first_name);
            formData.append('last_name', data.last_name);
            formData.append('message', data.message);
            return axios.post(`${state.baseURL}admin/reviews/${data.mode == 'edit' ? data.id : ''}`, formData)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeAdminReview({state}, data) {
            return axios.delete(`${state.baseURL}admin/reviews/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        reviewsGet({state}) {
            return axios.get(`${state.baseURL}reviews`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getAllHomeListings({state}) {
            return axios.get(`${state.baseURL}search/home-listings`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getSubscribes({state}) {
            return axios.get(`${state.baseURL}admin/subscribers`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        removeSubscriber({state}, data) {
            return axios.delete(`${state.baseURL}admin/subscribers/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })

        },
        getAdminAmenities({state}) {
            return axios.get(`${state.baseURL}admin/amenities`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getListAmenities({state}) {
            return axios.get(`${state.baseURL}list/amenities`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        createEditAmenity({state}, data) {
            if(data.mode == 'new') {
                return axios.post(`${state.baseURL}admin/amenities`, {
                    name: data.name
                })
                    .then((response) => {
                        return response
                    })
                    .catch((error) => {
                        return error
                    })
            } else {
                return axios.post(`${state.baseURL}admin/amenities/update`, {
                    name: data.name,
                    amenity_id: data.id
                })
                    .then((response) => {
                        return response
                    })
                    .catch((error) => {
                        return error
                    })
            }
        },
        deleteAdminAmenity({state}, data) {
            return axios.delete(`${state.baseURL}admin/amenities/${data}`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getDashboardData({state}) {
            return axios.get(`${state.baseURL}statistics`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        getAdminUserData({state}) {
            return axios.get(`${state.baseURL}admin/user`)
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return error
                })
        },
        updateAdminUserProfile({state, commit}, data) {
            let formData = new FormData();
            
            // Добавляем текстовые поля
            formData.append('email', data.email);
            formData.append('first_name', data.first_name);
            formData.append('last_name', data.last_name);
            if (data.address) {
                formData.append('address', data.address);
            }
            if (data.city) {
                formData.append('city', data.city);
            }
            if (data.country) {
                formData.append('country', data.country);
            }
            if (data.postal_code) {
                formData.append('postal_code', data.postal_code);
            }
            if (data.about_me) {
                formData.append('about_me', data.about_me);
            }
            
            // Добавляем файл изображения, если он есть
            if (data.profile_image && data.profile_image instanceof File) {
                formData.append('profile_image', data.profile_image);
            }
            
            return axios.post(`${state.baseURL}admin/user-profile`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response.data && response.data.user) {
                        const userData = response.data.user;
                        localStorage.setItem('logInUser', JSON.stringify(userData));
                        commit('addUserData', userData);
                    }
                    return response
                })
                .catch((error) => {
                    return error
                })
        }
    },

    getters: {
        accessToken: state => state.access_token,
    },
    modules: {},
})
